import { LoginForm } from '@/components/organisms';
import { Icon } from '@/components/atoms';

export default function LoginPage() {
  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 p-12 flex-col justify-between relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <circle cx="20" cy="20" r="1.5" fill="white" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>

        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm">
              <Icon name="Sprout" size={32} className="text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">FPO ERP System</h1>
              <p className="text-primary-100 text-sm">Agricultural Management Platform</p>
            </div>
          </div>
        </div>

        <div className="relative z-10 space-y-8">
          <div>
            <h2 className="text-4xl font-bold text-white mb-4">
              Empowering Farmers,<br />Growing Together
            </h2>
            <p className="text-primary-100 text-lg leading-relaxed">
              Streamline your FPO operations with our comprehensive ERP solution.
              Manage inputs, track outputs, and grow your agricultural business efficiently.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-4 border border-white border-opacity-20">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Users" size={20} className="text-primary-100" />
                <span className="text-white font-semibold">284+</span>
              </div>
              <p className="text-primary-100 text-sm">Active Members</p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-4 border border-white border-opacity-20">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="TrendingUp" size={20} className="text-primary-100" />
                <span className="text-white font-semibold">₹12.5L</span>
              </div>
              <p className="text-primary-100 text-sm">Monthly Revenue</p>
            </div>
          </div>
        </div>

        <div className="relative z-10">
          <p className="text-primary-200 text-sm">
            Trusted by Farmer Producer Organizations across India
          </p>
        </div>
      </div>

      {/* Right Panel - Login Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-neutral-50">
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="bg-primary-100 p-3 rounded-xl">
              <Icon name="Sprout" size={28} className="text-primary-600" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-neutral-900">FPO ERP System</h1>
              <p className="text-neutral-600 text-sm">Agricultural Management</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl border border-neutral-200 p-8">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900">Welcome back</h2>
              <p className="mt-2 text-neutral-600">Sign in to your account to continue</p>
            </div>

            <LoginForm
              showRememberMe={false}
              showForgotPassword={true}
              onForgotPassword={() => {
                alert('Forgot password functionality coming soon');
              }}
            />

            <div className="mt-6 pt-6 border-t border-neutral-200">
              <p className="text-center text-sm text-neutral-600">
                Don't have an account?{' '}
                <a
                  href="/register"
                  className="font-semibold text-primary-600 hover:text-primary-700 transition-colors"
                >
                  Create account
                </a>
              </p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-neutral-500">
              By signing in, you agree to our{' '}
              <a href="#" className="text-primary-600 hover:underline">Terms of Service</a>
              {' '}and{' '}
              <a href="#" className="text-primary-600 hover:underline">Privacy Policy</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
